module.exports = __webpack_public_path__ + "static/media/DSC_0041.477fd174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0041.jpg
// module id = 548
// module chunks = 0